import _ from 'lodash';

import { inject } from '../utils';
import * as device from '../utils/mobile';

class Features {
  constructor(session, store) {
    this.session = session;
    this.store = store;
  }

  get permissions() {
    const {
      session: {
        permissions,
      },
    } = this.store.getState();

    return _.chain(permissions.permissionGroups)
      .map('attributes.permissions')
      .concat()
      .flatten()
      .uniq()
      .value();
  }

  hasPermission(permission) {
    return this.permissions.includes(permission);
  }

  hasAffiliateConfig(feature) {
    const config = this.session.getAffiliateConfig();
    return config[feature] === 'true';
  }

  get chat() {
    return this.hasAffiliateConfig('enable_chat') &&
      device.hasChatSupport() &&
      this.hasPermission('chat.full');
  }

  get localization() {
    return this.hasAffiliateConfig('is_localization_enabled');
  }
}

inject(Features, [
  'SessionService',
  'Store',
]);
export default Features;



// WEBPACK FOOTER //
// ./src/services/Features.js